import { withErrorBoundary } from "@sentry/nextjs";
import NextImage, { ImageProps } from "next/image";
import { createLoaderWithTransform, Transform } from "components/Image/createLoaderWithTransform";

interface Props extends ImageProps {
  transform?: Transform;
}

const Image = withErrorBoundary(({ className = "", transform = undefined, style, alt, ...props }: Props) => {
  const transformDefined = transform ?? { format: "auto" };

  return (
    <NextImage
      placeholder="blur"
      // Base64 encoded 1x1 gray png
      blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mM8fOjgGQAHqgMUtmYy8QAAAABJRU5ErkJggg=="
      {...props}
      loader={createLoaderWithTransform(transformDefined)}
      alt={alt ?? ""}
      className={className}
      style={style}
    />
  );
}, {});

export { Image };
